// Hero copy per ad variant. ?v=quiz sells the free assessment, ?v=book sells the session.
export const HERO_VARIANTS = {
  default: {
    eyebrow: "1-on-1 Behavioural Science",
    headline: (
      <>
        Outsmart Your Toxic <br />
        <span className="text-[#D4AF37]">Boss</span> With Science
      </>
    ),
    subhead: (
      <>
        Sixty minutes with a behavioural scientist who has studied thousands of dark triad leaders. You leave with
        the counter-strategies for your exact situation.{" "}
        <span className="text-white font-medium">
          This isn't therapy. This isn't coaching. This is what actually works.
        </span>
      </>
    ),
    primary: { label: "Book a Consultation", action: "book" },
    secondary: { label: "Take the 2-Minute Test", action: "quiz" },
  },
  quiz: {
    eyebrow: "Free 2-Minute Assessment",
    headline: (
      <>
        Is Your Boss <br />
        <span className="text-[#D4AF37]">Toxic</span>, <br />
        Or Just Difficult?
      </>
    ),
    subhead: (
      <>
        Seven questions, built on dark triad research, tell you which traits you are actually dealing with.{" "}
        <span className="text-white font-medium">
          You get the breakdown instantly — no account, no email needed to see it.
        </span>
      </>
    ),
    primary: { label: "Take the 2-Minute Test", action: "quiz" },
    secondary: { label: "Book a Session", action: "book" },
  },
  book: {
    eyebrow: "1-on-1 Behavioural Science",
    headline: (
      <>
        Get a Scientist's <br />
        Read on <span className="text-[#D4AF37]">Your Boss</span>
      </>
    ),
    subhead: (
      <>
        Sixty minutes with a behavioural scientist who has studied thousands of toxic-leadership cases.{" "}
        <span className="text-white font-medium">
          You leave with the specific counter-strategies for your situation — not general advice.
        </span>
      </>
    ),
    primary: { label: "Book a Consultation", action: "book" },
    secondary: { label: "See What's Included", action: "services" },
  },
};
